import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Divider } from '@mui/material';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import { withTranslation } from 'react-i18next';
import { EUR_CURRENCY } from '../../constants';
import { ResultWrapper, BoldTextWrapper } from 'features/simulator/SimulatorStyles';
import { Card, Button } from '@totalsoft/rocket-ui';
import WrappedLinearProgress from 'components/common/WrappedLinearProgress';

const ResultItem = ({ t, itemsLoaded, item, loadAssetImage, images, onAssetSelected, savingOffer }) => {
  const [assetImage, setAssetImage] = useState();

  useEffect(() => {
    setAssetImage(item.imageUrl || loadAssetImage(item.assetHierarchyId));
  }, [item, loadAssetImage]);

  useEffect(() => {
    !item.imageUrl && setAssetImage(loadAssetImage(item.assetHierarchyId));
  }, [images, item.assetHierarchyId, item.imageUrl, loadAssetImage]);

  return (
    <ResultWrapper item xs={12} sm={6} md={4} lg={3}>
      <Card icon={DriveEtaIcon} iconColor='primary'>
        <Grid container spacing={1} direction='column' alignItems='center'>
          <Grid item xs={12}>
            {<img src={assetImage} alt='' width='100' />}
            <Divider light />
          </Grid>
          <Grid container item xs={12} justifyContent='center'>
            {itemsLoaded && item.assetHierarchyName ? (
              <BoldTextWrapper> {itemsLoaded && item.assetHierarchyName}</BoldTextWrapper>
            ) : (
              <Grid item xs={6}>
                {' '}
                <WrappedLinearProgress />
              </Grid>
            )}
          </Grid>
          <ResultWrapper container item xs={12} justifyContent='center'>
            {t('Simulator.Results.ListPrice')}
            <BoldTextWrapper>
              : {t('DECIMAL2', { number: item.listPrice })} {EUR_CURRENCY}
            </BoldTextWrapper>
          </ResultWrapper>
          <ResultWrapper container item xs={12} justifyContent='center'>
            {t('Simulator.Results.MonthlyRate')}
            <BoldTextWrapper>
              : {t('DECIMAL2', { number: item.monthlyRate })} {EUR_CURRENCY}
            </BoldTextWrapper>
          </ResultWrapper>
          <ResultWrapper container item xs={12} justifyContent='center'>
            <Button color='primary' disabled={!itemsLoaded || savingOffer} onClick={() => onAssetSelected(item, assetImage)}>
              {t('Simulator.Results.Select')}
            </Button>
          </ResultWrapper>
        </Grid>
      </Card>
    </ResultWrapper>
  );
};
ResultItem.propTypes = {
  t: PropTypes.func.isRequired,
  itemsLoaded: PropTypes.bool.isRequired,
  item: PropTypes.object.isRequired,
  loadAssetImage: PropTypes.func.isRequired,
  images: PropTypes.object,
  onAssetSelected: PropTypes.func.isRequired,
  savingOffer: PropTypes.bool.isRequired
};

export default withTranslation()(ResultItem);
